import { defineComponent as o, h as t } from "vue";
import p from "./ghl-ui.es1034.js";
import s from "./ghl-ui.es854.js";
import n from "./ghl-ui.es908.js";
const u = {}, d = o({
  name: "InputGroup",
  props: u,
  setup(r) {
    const {
      mergedClsPrefixRef: e
    } = s(r);
    return n("-input-group", p, e), {
      mergedClsPrefix: e
    };
  },
  render() {
    const {
      mergedClsPrefix: r
    } = this;
    return t("div", {
      class: `${r}-input-group`
    }, this.$slots);
  }
});
export {
  d as default,
  u as inputGroupProps
};
